import PropTypes from "prop-types";
import { Accordion, AccordionTab, Iconify } from "@repo/design-system/components/ui";

const InfoField = ({ label, value }) => (
  <div className="sp-info-field">
    <span className="sp-info-label">{label}</span>
    <span className="sp-info-value">{value || "-"}</span>
  </div>
);

const CurrentAcademicInfo = ({ currentAcademicInfo = {}, isOpen, onToggle }) => {
  const current = currentAcademicInfo || {};

  const headerTemplate = (
    <div className="flex align-items-center gap-2">
      <span className="flex align-items-center">
        <Iconify icon="solar:square-academic-cap-bold" width={16} />
      </span>
      <span>Current Academic Information</span>
    </div>
  );

  return (
    <Accordion activeIndex={isOpen ? 0 : null} onTabChange={onToggle}>
      <AccordionTab header={headerTemplate}>
        <div className="sp-info-grid">
          <InfoField label="University :" value={current.universityName} />
          <InfoField label="Institute :" value={current.instituteName} />
          <InfoField label="Programme Level :" value={current.levelName} />
          <InfoField label="Degree/Program:" value={current.programmeName} />
          <InfoField label="Branch :" value={current.branchName} />
          <InfoField label="Enrollment No. :" value={current.enrollmentNo} />
          {/* <InfoField label="Admission ID :" value={current.admissionId} /> */}
          <InfoField label="Admission Year :" value={current.admissionYear} />
          <InfoField label="Admission Type :" value={current.admissionType} />
          <InfoField label="Current Semester :" value={current.currentSemYear} />
          <InfoField label="Agency :" value={current.agencyName} />
          {/* <InfoField label="Category :" value={current.categoryName} /> */}
          <InfoField label="Academic Status :" value={current.status} />
          {/* <InfoField label="APAAR / ABC ID :" value={abcId} /> */}
        </div>
      </AccordionTab>
    </Accordion>
  );
};

CurrentAcademicInfo.propTypes = {
  currentAcademicInfo: PropTypes.object,
  abcId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default CurrentAcademicInfo;
